import React, { useEffect, useRef, useState } from 'react';
import Avatar, { genConfig } from 'react-nice-avatar';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../services/operations/auth';
import Transition from '../../utils/Transition';

function UserMenu({
    email,
    username,
    align
}) {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const trigger = useRef(null);
    const dropdown = useRef(null);

    const dispatch = useDispatch()
    const navigate = useNavigate()



    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!dropdown.current) return;
            if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    const handleSignOut = () => {
        dispatch(logout(navigate))
        setDropdownOpen(!dropdownOpen)
    }
    const config = genConfig(`${email}`)

    return (
        <div className="relative inline-flex">
            <button
                ref={trigger}
                className="inline-flex justify-center items-center group"
                aria-haspopup="true"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
            >
                <Avatar className="w-10 h-10 rounded-full" {...config} />
                {/* <img className="w-10 h-10 rounded-full" src={UserAvatar} width="32" height="32" alt="User" /> */}
                {/* <div className="flex items-center truncate">
                    <span className="line-clamp-1 ml-2 text-sm font-medium group-hover:text-gray-800">{username}</span>
                    <svg className="w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400" viewBox="0 0 12 12">
                        <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                    </svg>
                </div> */}
            </button>

            <Transition
                className={`origin-top-right z-10 absolute top-full min-w-44 bg-white dark:bg-dark_50 dark:border-zinc-800 border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${align === 'right' ? 'right-0' : 'left-0'}`}
                show={dropdownOpen}
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div
                    ref={dropdown}
                    onFocus={() => setDropdownOpen(true)}
                    onBlur={() => setDropdownOpen(false)}
                >
                    <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-gray-200 dark:border-zinc-700">
                        {/* <div className="font-medium text-zinc-800 dark:text-zinc-200">{email}</div> */}
                        <div className="font-medium text-gray-600 dark:text-gray-400  text-sm mt-1">#{username}</div>
                    </div>
                    <div>
                        <div>
                            <button
                                className="font-medium text-sm text-brand_50 hover:text-brand flex items-center py-1 px-3"
                                onClick={() => handleSignOut()}
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    )
}

export default UserMenu;